import { DateFromNow, SimpleModal, t } from "@comact/crc";
import { Badges, Line, Span, Table, styled } from "@comact/crc/modules/kit";
import React from "react";
import { ISalesforceCase, ISalesforceCaseActivity } from "../model";

const TableRowStyled = styled(Table.tr)`
    height: 60px;
`;

const LineWrapStyled = styled(Line)`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
    &::after {
        content: "-";
        visibility: hidden;
    }
`;
interface IRowProps extends ISalesforceCase {
    statusKey: string;
    statusLabel: string;
}

const SalesforceCasesRow = React.memo<IRowProps>(({ statusKey, statusLabel, caseNumber, subject, nextStep, machine, createdDate, responsibleTeam, caseOwner, contact, activities }) => {
    const [isOpen, setIsOpen] = React.useState(false);

    const handleOpen = React.useCallback(() => {
        setIsOpen(true);
    }, []);

    const handleClose = React.useCallback(() => {
        setIsOpen(false);
    }, []);

    const Badge = React.useMemo(() => {
        switch (statusKey) {
            case "Closed": return Badges.Success;
            case "In_Progress": return Badges.Primary;
            case "On_Hold": return Badges.Warn;
            default: return Badges.Base;
        }
    }, [statusKey]);

    return (
        <>
            <TableRowStyled kDesign="base" onClick={handleOpen}>
                <Table.td>
                    <Span kColor="light" kFontWeight="light"><i>{caseNumber}</i></Span>
                </Table.td>
                <Table.td kWidth="40%" kMaxWidth="400px">
                    <LineWrapStyled kFontWeight="bold">{subject}</LineWrapStyled>
                    {nextStep && (
                        <LineWrapStyled kFontWeight="light" kColor="light">{nextStep}</LineWrapStyled>
                    )}
                </Table.td>
                <Table.td><Span kFontWeight="light">{machine?.name}</Span></Table.td>
                <Table.td>{responsibleTeam}</Table.td>
                <Table.td>{caseOwner}</Table.td>
                <Table.td>{contact?.name || "-"}</Table.td>
                <Table.td>
                    <LineWrapStyled>{createdDate && <Span kFontWeight="bold"><DateFromNow timestamp={(new Date(createdDate)).getTime()} /></Span>}</LineWrapStyled>
                </Table.td>
                <Table.td><Badge children={statusLabel} /></Table.td>
            </TableRowStyled>
            {isOpen && (

                <SimpleModal onClose={handleClose} constentStyle={{ width: "900px" }} header={t("salesforce.caseActivityTitle") + caseNumber}>
                    <Table.table kMode="card">
                        <Table.thead>
                            <Table.tr>
                                <Table.th>{t("salesforce.caseActivityColomns.name")}</Table.th>
                                <Table.th>{t("salesforce.caseActivityColomns.type")}</Table.th>
                                <Table.th>{t("salesforce.caseActivityColomns.modifiedBy")}</Table.th>
                                <Table.th>{t("salesforce.caseActivityColomns.created")}</Table.th>
                            </Table.tr>
                        </Table.thead>
                        <Table.tbody>
                            {activities.records.length > 0
                                ? (
                                    activities.records.map((act: ISalesforceCaseActivity) => (
                                        <Table.tr key={act.id}>
                                            <Table.td>{act.name}</Table.td>
                                            <Table.td>{act.type}</Table.td>
                                            <Table.td>{act.lastModifiedBy.name}</Table.td>
                                            <Table.td>
                                                <LineWrapStyled>{act.createdDate && <Span kFontWeight="bold"><DateFromNow timestamp={(new Date(act.createdDate)).getTime()} /></Span>}</LineWrapStyled>
                                            </Table.td>
                                        </Table.tr>
                                    ))
                                )
                                : (
                                    <Table.tr>
                                        <Table.td colSpan={4} style={{ textAlign: "center", fontStyle: "bold" }}>
                                            {t("salesforce.noActivities")}
                                        </Table.td>
                                    </Table.tr>
                                )}
                        </Table.tbody>
                    </Table.table>
                </SimpleModal>
            )}
        </>
    );
});

export default SalesforceCasesRow;
